import { FunctionalComponent, h } from "preact";
import { SubmenuContainerStyled, SubmenuStyled } from "./submenu.styled";

export const Submenu: FunctionalComponent = (props) => (
	<SubmenuContainerStyled>
		<SubmenuStyled>
			{props.children}
		</SubmenuStyled>
	</SubmenuContainerStyled>
);